module.exports = __webpack_public_path__ + "img/preview_partly_jobs.1a879151.gif";